import React, { useEffect, useRef } from 'react';

interface IndeterminateCheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  indeterminate?: boolean;
  ariaLabel?: string;
}

export const IndeterminateCheckbox: React.FC<IndeterminateCheckboxProps> = ({
  indeterminate = false,
  className = '',
  ariaLabel,
  onClick,
  ...rest
}) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [indeterminate, rest.checked]);

  return (
    <input
      type="checkbox"
      ref={ref}
      aria-label={ariaLabel}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      className={`rounded border-cf-border bg-cf-bg text-cf-accent focus:ring-1 focus:ring-cf-accent/40 focus:ring-offset-0 h-3.5 w-3.5 cursor-pointer transition-colors ${className}`}
      {...rest}
    />
  );
};
